
import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

import { useDisciplinePrivileges } from './discipline-privileges.hook'
import { useDisciplineGeneralForm } from './discipline-general-form.hook'

interface DisciplineGeneralControlsReturn {
  canManageDisciplines: ComputedRef<boolean>
  refIsSaving: ComputedRef<boolean>
  refPaymentLinksUrl: ComputedRef<string | null>
  setSubmitUpdate: () => Promise<void>
}

export const useDisciplineGeneralControls = (): DisciplineGeneralControlsReturn => {
  const route = useRoute()
  const { canManageDisciplines } = useDisciplinePrivileges()
  const { refIsSaving, setSubmitUpdate } = useDisciplineGeneralForm()

  const refPaymentLinksUrl = computed<string | null>(() =>
    resolveUrl(AppRoute.DisciplinesOrdersCreate, { id: route.params.id as string }))

  return {
    canManageDisciplines,
    refIsSaving,
    refPaymentLinksUrl,
    setSubmitUpdate,
  }
}
